<template>
  <div class="cus-chat-supervise">
    <div class="cus-chat-supervise-search">
      <el-select v-model="formInline.bindStatus" placeholder="请选择" size="mini" @change="getTableData(true)"
        style="width: 150px">
        <el-option v-for="item in options" :key="item.bindStatus" :label="item.label" :value="item.bindStatus">
        </el-option>
      </el-select>
      <div style="width:250px;display:inline-block;">
        <el-input size="mini" v-model="formInline.queryCustomerChat" placeholder="档案名/卡号/昵称/备注名"
          @blur="getTableData(true)" @clear="getTableData(true)" clearable>
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div style="display: flex;align-items: center;">
        <el-button size="mini"> 上次聊天 </el-button>
        <el-date-picker v-model="dateArr" :picker-options="pickerOptions" size="mini" type="daterange" :editable="false"
          value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始时间" end-placeholder="结束时间"
          @change="selectTime" clearable style="width: 240px; border-radius: 0 4px 4px 0;">
        </el-date-picker>
      </div>
      <div class="code-search-left">
        <el-button size="mini"> 跟进员工 </el-button>
        <el-tag title="选择员工" class="add-per-input" :closable="this.searchMenNames.length === 0 ? false : true"
          @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember(true)">
          <span v-if="searchMenNames.length === 0">选择员工</span>
          <div class="span-tips">
            <span v-for="(item, index) in searchMenNames" :key="index">{{ item.name
            }}<span v-show="searchMenNames.length > 1 && index != searchMenNames.length - 1
                ">,</span></span>
          </div>
        </el-tag>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table size="small" :data="tableData" fit highlight-current-row align="center"
          :header-cell-style="{ background: '#F9F9F9' }" :height="tableHeight" ref="cusChatTable"
          style="font-size: 13px">
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <!-- <el-table-column prop="rowNumb" label="NO." width="70px"/> -->
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ getGlobalIndex(scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="客户" min-width="250" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.name
              }}<span style="color: rgb(70, 189, 10)" v-if="scope.row.type == 1">
                @微信</span><span style="color: rgb(8, 168, 231)" v-else>
                @{{ scope.row.corpName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="employee" label="档案名" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.ctmName != null">{{
                scope.row.ctmName
              }}</span>
              <span v-else style="color: rgb(228, 96, 63)">未绑定</span>
            </template>
          </el-table-column>
          <el-table-column prop="ctmCode" label="卡号" min-width="180"> </el-table-column>

          <!-- <el-table-column prop="remark" label="备注名" /> -->
          <el-table-column prop="chargePerson" label="跟进员工" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #FFAA33" v-if="scope.row.chargePerson == null">无跟进员工</span>
              <span v-else>{{ scope.row.chargePerson }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="recentTime" label="上次聊天" width="200">
            <template slot-scope="scope">
              <span style="color: #FFAA33" v-if="scope.row.recentTime == null">无上次聊天时间</span>
              <span v-else>{{ scope.row.recentTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="130">
            <template slot-scope="scope">
              <el-link style="font-size:13px;" :underline="false" type="primary" icon="el-icon-view"
                @click.native="viewContent(scope.$index, scope.row)">聊天内容</el-link>
              <!-- <el-link v-else style="font-size:13px;" :underline="false" type="primary" icon="el-icon-view"
                @click.native="test(scope.$index, scope.row)">聊天内容</el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination style="text-align: end;margin-top: 6px;" @current-change="changePage" @size-change="changeSize"
      :current-page.sync="formInline.page" :page-size.sync="formInline.size"
      layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[20, 50, 100, 200, 500]">
    </el-pagination>
    <el-dialog :title="chatTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="50vw"
      :center="true" :close-on-press-escape="true" @close="close">
      <!-- <div style=""> -->
      <ChatContentDia :idData="uid" v-if="newChatDialogVisible" />
      <!-- <CusChatView :idData="uid" v-if="environment === 'other' || !isNewEdition" /> -->
      <!-- </div> -->
    </el-dialog>
    <StaffTree :title="title" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember="currentSelectMember"
      @closeTree="closeTree" @clickSubmitTree="clickSubmitTree"></StaffTree>
  </div>
</template>
<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import {
  getChatQwAndYuanNeiCUstomer,
  getAuditCustomerListApi,
} from "@/api/customer/customer.js";
import { getSessionVersion } from "@/api/staff/staff.js";
import CusChatView from "../chat/components/CusChatView";
// import ChatContentDia from './components/ChatContentDia'
import ChatContentDia from "./components/newChat/ChatContentDia.vue";
export default {
  name: "CusChatSupervise",
  components: {
    CusChatView,
    ChatContentDia,
    StaffTree
  },
  data() {
    return {
      dateArr: [],
      title: "选择使用成员",
      dialogVisibleTree: false, //成员添加
      currentSelectMember: [], //组件中要显示-选中的成员
      searchMenNames: [], //当前 搜索框-选中的成员
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 当前时间减一天，确保可以选择今天
        }
      },

      tableData: [],
      tableHeight: 500,
      dialogVisible: false,
      // loading: true,
      uid: "",
      chatTitle: "",
      options: [
        {
          bindStatus: 10,
          label: "不限",
        },
        {
          bindStatus: 1,
          label: "已绑定档案",
        },
        {
          bindStatus: 0,
          label: "未绑定档案",
        },
      ],
      total: 0,
      formInline: {
        page: 1,
        size: 20,
        bindStatus: 10,
        queryCustomerChat: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      /** 是否新版本会话 */
      // isNewEdition: true,
      /** 控制新版聊天记录弹窗显示隐藏 */
      newChatDialogVisible: false,
      /** 当前所属环境 com-wx-mobile手机端企业微 com-wx-pc电脑端企微 other其他环境（外部浏览器）*/
      // environment: "",
      // 提示实例，防止弹出多个提示
      messageInstance: null,
    };
  },
  async created() {
    // 获取当前环境
    // this.environment = window.localStorage.getItem("environment") || await this.getEnvironment()
    // console.log("this.environment+++", this.environment);
    /** 获取判断新旧版本参数 */
    // await this.getVersionsParams()
    this.getTableData();
  },
  methods: {
    /**页码改变 */
    changePage(val) {
      this.formInline.page = val
      this.getTableData()
    },
    /**页大小改变 */
    changeSize(val) {
      this.formInline.page = 1
      this.formInline.size = val
      this.getTableData()
    },
    getGlobalIndex(index) {
      return (this.formInline.page - 1) * this.formInline.size + index + 1;
    },
    // 树
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    //树确认回调
    clickSubmitTree(val) {
      this.currentSelectMember = val.currentMember;
      this.formInline.queryStaff = [];
      this.searchMenNames = val.currentIdName;
      val.sendArray.forEach((item) => {
        this.formInline.queryStaff.push(item.userId);
      });
      this.dialogVisibleTree = false;
      this.getTableData()
    },
    // 搜索-添加成员
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.formInline.queryStaff = [];
      this.getTableData(true)
    },

    // 时间处理
    selectTime(dataTime) {
      if (dataTime != null) {
        this.formInline.startTime = dataTime[0];
        this.formInline.endTime = dataTime[1];
      } else {
        this.formInline.startTime = null
        this.formInline.endTime = null

      }
      this.getTableData(true);
    },
    /**获取表格数据 */
    getTableData(isInit) {
      if (isInit === true) {
        this.formInline.page = 1
      }

      this.tableData = []
      // if (this.isNewEdition && this.environment !== 'other') {
      /** 新版走这里 */
      getAuditCustomerListApi(this.formInline, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code == 200) {
            this.tableData = res.data.records;
            this.total = Number(res.data.total || 0)
          } else {
            if (this.messageInstance) this.messageInstance.close();
          }
        })
        .catch((err) => {
          if (this.messageInstance) this.messageInstance.close();
          this.messageInstance = this.$message.error("获取失败，请稍后再试");
          console.log(err, "errr");
        });
      // } else {
      //   /** 旧版 */
      //   getChatQwAndYuanNeiCUstomer(parameter, localStorage.getItem("Authorization")).then(res => {
      //     if (res.error.code == 200) {
      //       this.tableData = res.data.result;
      //       this.pageparm.total = res.data.totals
      //       this.pageparm.currentPage = this.formInline.page
      //       this.pageparm.pageSize = this.formInline.size
      //     }
      //   })
      // }
    },


    clear() {
      this.formInline.name = "";
    },

    test(index, row) {
      //alert("你好")
      // console.log("faffff")
      //console.log(row);
      this.uid = row.externalUserId;
      // console.log(this.uid);
      this.dialogVisible = true;
      this.chatTitle = row.name + "的聊天内容";
    },

    /** 查看聊天内容 */
    viewContent(index, row) {
      this.uid = row.externalUserId;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.newChatDialogVisible = true;
      });
      this.chatTitle = row.name + "的聊天内容";
    },

    controlHeight() {
      this.$nextTick(function () {
        this.tableHeight =
          window.innerHeight - this.$refs.cusChatTable.$el.offsetTop - 226;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          self.tableHeight =
            window.innerHeight - self.$refs.cusChatTable.$el.offsetTop - 226;
        };
      });
    },

    /** 获取判断新旧版本参数 */
    // async getVersionsParams() {
    //   await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
    //     if (res && res.error && res.error.code === 200) {
    //       this.isNewEdition = res.data
    //       window.localStorage.setItem("isNewEdition", this.isNewEdition);
    //     } else {
    //       this.$message.error("获取版本参数失败")
    //     }
    //   }).catch((err) => {
    //     this.$message.error("获取版本参数失败")
    //     console.log("新旧版本参数获取失败", err);
    //   });
    // },
    /** 弹窗关闭 */
    close() {
      console.log("弹窗关闭");
      this.dialogVisible = false;
      this.newChatDialogVisible = false;
    },

    /** 获取当前环境 */
    // getEnvironment() {
    //   let isMobile = window.navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   ); // 是否手机端
    //   let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
    //   if (isComWx && isMobile) {
    //     //手机端企业微信
    //     this.environment = "com-wx-mobile";
    //   } else if (isComWx && !isMobile) {
    //     //PC端企业微信
    //     this.environment = "com-wx-pc";
    //   } else {
    //     //其他环境
    //     this.environment = "other";
    //   }
    //   window.localStorage.setItem("environment", this.environment);
    // },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["cusChatTable"].doLayout();
    });
  },
  mounted: function () {
    this.controlHeight();
  },
};
</script>
<style lang="scss" scoped>
.cus-chat-supervise {
  .cus-chat-supervise-search {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .el-dialog {
    min-width: 620px;
    max-width: 1200px;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #0f0f0f;
  }

  .el-dialog__body {
    padding: 5px 30px 20px !important;
  }
}

.code-search-left {
  display: flex;
  align-items: center;


  .add-per-input {
    display: flex;
    align-items: center;
    width: 230px;
    cursor: pointer;

    .span-tips {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .el-icon-close {
      line-height: 20px;
    }

  }

  .el-tag--plain {
    border-color: #dcdfe6;
    color: #c0c4cf;
  }
}
</style>
